import type React from "react";

// ─── Layout constants ─────────────────────────────────────────────────────────
export const PX_PER_SEC          = 15;
export const LABEL_W             = 160;
export const SFX_CLIP_DUR        = 15;
export const CLIP_BOTTOM_Y       = 83;
export const MAX_CLIPS_PER_KIND  = 12;
export const MAX_USER_TRACKS     = 6;

// Default track ids — legacy clips (no track_id) are migrated onto these on load.
export const DEFAULT_AMBIENT_TRACK_ID = "default-ambient";
export const DEFAULT_SFX_TRACK_ID     = "default-sfx";

export const genTrackId = () => `track_${Math.random().toString(36).slice(2, 10)}`;

// ─── Gallery tabs ─────────────────────────────────────────────────────────────
export type GalleryTab = "Sons ambiants" | "Effets sonores" | "Mes sons";
export const GALLERY_TABS: GalleryTab[] = ["Sons ambiants", "Effets sonores", "Mes sons"];

// ─── Pure helpers ─────────────────────────────────────────────────────────────

/** Tag pill colour based on the sound's recommended use. */
export function mixTagStyle(tag: string): React.CSSProperties {
  if (tag === "Idéal fond")   return { background: "#cdffd1", color: "#04a404" };
  if (tag === "Idéal effet")  return { background: "#fdebf9", color: "#c8009c" };
  return { background: "#eff6ff", color: "#3b6fb0" };
}

/** Format seconds as HH:MM:SS. */
export function fmtTime(s: number): string {
  const hh = Math.floor(s / 3600).toString().padStart(2, "0");
  const mm = Math.floor((s % 3600) / 60).toString().padStart(2, "0");
  const ss = Math.floor(s % 60).toString().padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

/** Unwrap the nested `scenario` key that some API responses wrap their payload in. */
export function extractPayload(raw: Record<string, unknown>): Record<string, unknown> {
  if (raw.scenario && typeof raw.scenario === "object")
    return raw.scenario as Record<string, unknown>;
  return raw;
}
